import Add from "@mui/icons-material/Add";
import Delete from "@mui/icons-material/Delete";
import Button from "@mui/material/Button";
import { GridRowId } from "@mui/x-data-grid";
import { useCallback } from "react";
import { useNavigate } from "react-router";
import DeleteConfigsDialog from "../useDialogs/DeleteConfigDialog";
import { useDialogs } from "../useDialogs/useDialogs";
import useSession from "../useSession/useSession";
import PageHeader from "./PageHeader";
import PageHeaderToolbar from "./PageHeaderToolbar";

function ConfigListingPageToolbar({
  selection,
}: {
  selection: readonly GridRowId[];
}) {
  const dialogs = useDialogs();
  const navigate = useNavigate();

  return (
    <PageHeaderToolbar>
      <Button
        disabled={!selection || selection.length < 1}
        variant="contained"
        color="error"
        className="ml-5"
        onClick={async () => {
          await dialogs.open(DeleteConfigsDialog, selection);
        }}
      >
        <Delete />
        Supprimer
      </Button>
      <Button
        variant="contained"
        className="ml-5"
        onClick={() => navigate("/orion/config/new")}
      >
        <Add />
        Nouvelle configuration
      </Button>
    </PageHeaderToolbar>
  );
}
function ConfigListingHeader({
  selection,
}: {
  selection: readonly GridRowId[];
}) {
  const session = useSession();

  const PageToolbarComponent = useCallback(
    () =>
      (session?.OrionContributorGroups ?? []).length > 0 && (
        <ConfigListingPageToolbar selection={selection} />
      ),
    [selection, session]
  );
  return <PageHeader slots={{ toolbar: PageToolbarComponent }} />;
}

export default ConfigListingHeader;
